'use client';

import { useTranslations } from 'next-intl';
import React, { FC, memo, useEffect } from 'react';
import { twMerge } from 'tailwind-merge';

import { useStyleContext, useGTMContext, TAiVideo } from '@/src/providers';

const styles = {
  optionWrap: 'flex items-center',
  option: 'cursor-pointer flex items-center space-x-2 shrink-0 max-w-full',
  circle:
    'w-4 h-4 shrink-0 flex items-center justify-center rounded-full border-2 bg-transparent transition-all',
  circleActive: 'border-rose',
  circleInactive: 'border-gray-400',
  circleInner: 'block w-1.5 h-1.5 rounded-full bg-fill-rose',
  optionLabel: 'text-sm font-medium text-label-secondary',
  optionLabelActive: 'text-label-primary',
};

const AvatarItemComponent: FC = () => {
  const t = useTranslations('imageModal');
  const { isYourPhoto, activeStyle, setIsYourPhoto, isPhotosessionPhoto } =
    useStyleContext();
  const sendGTM = useGTMContext();

  const handleAvatarChange = () => {
    setIsYourPhoto(true);
    sendGTM({
      event: 'Check_box',
    });
  };

  const id = 'your-photo';

  useEffect(() => {
    if (!(activeStyle as TAiVideo).videoLookId || isPhotosessionPhoto) {
      setIsYourPhoto(true);
    } else {
      setIsYourPhoto(false);
    }
  }, [activeStyle, setIsYourPhoto]);

  return (
    <div key={id} className={styles.optionWrap}>
      <input
        type="radio"
        id={id}
        name="radioGroup"
        value={id}
        checked={isYourPhoto}
        onChange={handleAvatarChange}
        className="hidden"
      />
      <label htmlFor={id} className={styles.option}>
        <span
          className={twMerge(
            styles.circle,
            isYourPhoto ? styles.circleActive : styles.circleInactive,
          )}
        >
          {isYourPhoto && <span className={styles.circleInner}></span>}
        </span>
        <span
          className={twMerge(
            styles.optionLabel,
            isYourPhoto && styles.optionLabelActive,
          )}
        >
          {t('yourPhoto')}
        </span>
      </label>
    </div>
  );
};

export const AvatarYourPhoto = memo(AvatarItemComponent);
